module.exports = __webpack_public_path__ + "static/media/White.5e5e0a72.svg";